import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

export function ApprovalButtons(props) {
  return (
    <span>
      <Grid
        container
        sx={{
          my: 2,
        }}
        spacing={1}
      >
        <Grid item xs={5}>
          <Typography gutterBottom>Reason:</Typography>
        </Grid>
        <Grid item xs={7}>
          <TextField
            error={props.errors && props.errors.comments && true}
            id="outlined-multiline-flexible"
            label="Approval/Rejection Reason"
            multiline
            fullWidth
            rows={4}
            value={props.value.comments}
            onChange={props.handleChange}
            helperText={
              props.errors && props.errors.comments ? props.errors.comments : ""
            }
          />
        </Grid>

        <Grid item xs={6}>
          <Button
            variant="contained"
            onClick={(e) =>
              props.handleApproval({
                e,
                approval: true,
                value: props.value,
              })
            }
            fullWidth
            sx={{
              mr: "5px",

              textTransform: "capitalize",
            }}
            color="success"
          >
            Approve
          </Button>
        </Grid>
        <Grid item xs={6}>
          <Button
            variant="contained"
            fullWidth
            onClick={(e) =>
              props.handleApproval({
                e,
                approval: false,
                value: props.value,
              })
            }
            sx={{
              textTransform: "capitalize",
            }}
            color="error"
          >
            {props.requestResubmission ? "Request Resubmission" : "Reject"}
          </Button>
        </Grid>
      </Grid>
    </span>
  );
}
